import React, { useEffect, useRef, useState } from 'react'
import BlockTitle from '../common/BlockTitle'
// import classnames from 'classnames'
import { calculateStickyLimit, Sticky, Range } from '../common/Stiky'
// import ScrollElememt from '../../../components/ScrollElement'
// import { Iconfont } from '../../../components/Icon'
import useRandomId from '../../../hooks/useRandomId'
import { partnerImageUrls } from '../../../assets'
import './style.scss'
import BlockImage from '../common/BlockImage'

// const investors = partnerImageUrls.investor.map((url) => ({
//   img: url,
// }))

interface Partner {
  name: string
  img: string
  hoverImg?: string
}

const partners: Partner[] = [
  {
    name: 'Salus',
    img: partnerImageUrls.partner.partnerSalusImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverSalusImageUrl,
  },
  {
    name: 'DaoMaker',
    img: partnerImageUrls.partner.partnerDaoMakerImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverDaoMakerImageUrl,
  },
  {
    name: 'StarryNift',
    img: partnerImageUrls.partner.partnerStarryNiftImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverStarryNiftImageUrl,
  },
  {
    name: 'AlienSwap',
    img: partnerImageUrls.partner.partnerAlienSwapImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverAlienSwapImageUrl,
  },
  {
    name: 'MetaOasis',
    img: partnerImageUrls.partner.partnerMetaOasisImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverMetaOasisImageUrl,
  },
  {
    name: 'MirrorWorld',
    img: partnerImageUrls.partner.partnerMirrorWorldImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverMirrorWorldImageUrl,
  },
  {
    name: 'NFTB',
    img: partnerImageUrls.partner.partnerNFTBImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverNFTBImageUrl,
  },
  {
    name: 'SaaSGo',
    img: partnerImageUrls.partner.partnerSaasGoImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverSaasGoImageUrl,
  },
  {
    name: 'Web3Games',
    img: partnerImageUrls.partner.partnerWeb3GamesImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverWeb3GamesImageUrl,
  },
  {
    name: 'zkPass',
    img: partnerImageUrls.partner.partnerZKpassImageUrl,
    hoverImg: partnerImageUrls.partnerHover.partnerHoverZKpassImageUrl,
  },
]

type ConfidenceLimits = [Range, Range]

const TrustBy: React.FC = () => {
  const $containerRef = useRef<HTMLDivElement>(null)
  const [$container, set$container] = useState<HTMLDivElement | null>(null)
  const [$title, set$title] = useState<HTMLDivElement | null>(null)
  // const stickies = useMemo(() => {
  //   const ret: HTMLElement[] = []
  //   if ($title) {
  //     ret.push($title)
  //   }
  //   return ret
  // }, [$title])
  // const limits = useMemo<HighlightsLimits | null>
  const [limits, setLimits] = useState<ConfidenceLimits | null>(null)
  const titleOnceKey = useRandomId()
  // const membersOnceKey = useRandomId()

  useEffect(() => {
    if (!$container || !$title) return
    if (limits) return
    setLimits(calculateStickyLimit($container, [$title]) as ConfidenceLimits)
  }, [limits, $container, $title])

  useEffect(() => {
    set$container($containerRef.current)
  }, [])

  return (
    <div id="trustby" ref={$containerRef}>
      <Sticky range={limits?.[0]} el={$title} zIndex={101}>
        <BlockTitle
          title="Backer"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
        />
      </Sticky>
      <div className="content">
        {/* <BlockTitle
          title="Investor"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
          size="middle"
        />
        <div className="icons">
          {investors.map((part, i) => (
            <BlockImage src={part.img} key={i} autoOnceKey className="icon" />
          ))}
        </div> */}
        {/* <BlockTitle
          title="Partner"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
          size="middle"
        /> */}
        <div className="icons">
          {partners.map((part, i) => (
            <BlockImage
              src={part.img}
              hoverSrc={part.hoverImg}
              key={i}
              autoOnceKey
              className="icon"
              alt={part.name}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TrustBy
